export default {
  path: '/delivery-booking',
  component: () => import('@/views/delivery-booking/index.vue'),
  children: [
    {
      path: 'list',
      name: 'DeliveryBookingList',
      component: () => import('@/views/delivery-booking/pages/DeliveryBookingList.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'warehouse_manager',
          'warehouse',
          'merchandising_planner',
          'merchandiser'
        ]
      }
    },
    {
      path: 'detail/:id/grn',
      name: 'DeliveryBookingGRN',
      component: () => import('@/views/delivery-booking/pages/DeliveryBookingGRN.vue'),
      meta: {
        layout: 'Blank',
        middleware: [
          'auth',
          'management',
          'developer',
          'warehouse_manager',
          'warehouse',
          'merchandising_planner',
          'merchandiser'
        ]
      }
    },
    {
      path: 'daily-grn',
      name: 'DeliveryBookingDailyGRN',
      component: () => import('@/views/delivery-booking/pages/DeliveryBookingGRN.vue'),
      meta: {
        layout: 'Blank',
        middleware: [
          'auth',
          'management',
          'developer',
          'warehouse_manager',
          'warehouse',
          'merchandising_planner',
          'merchandiser'
        ]
      }
    },
    {
      path: 'booking-holiday',
      name: 'DeliveryBookingHoliday',
      component: () => import('@/views/delivery-booking/pages/BookingHoliday.vue'),
      meta: {
        middleware: ['auth', 'management', 'developer', 'warehouse_manager']
      }
    },
    {
      path: 'booking-slots',
      name: 'DeliveryBookingSlots',
      component: () => import('@/views/delivery-booking/pages/BookingSlots.vue'),
      meta: {
        middleware: ['auth', 'management', 'developer', 'warehouse_manager']
      }
    },
    {
      path: 'manual',
      name: 'DeliveryBookingManual',
      component: () => import('@/views/delivery-booking/pages/DeliveryBookingManual.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'warehouse_manager',
          'warehouse',
          'merchandising_planner',
          'merchandiser'
        ]
      }
    },
    {
      path: 'detail/:id',
      name: 'DeliveryBookingDetail',
      component: () => import('@/views/delivery-booking/pages/DeliveryBookingDetail.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'warehouse_manager',
          'warehouse',
          'merchandising_planner',
          'merchandiser'
        ]
      }
    }
  ]
}
